/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add service function
 */
export const AddServiceFunctionBody = zod.object({
  functionId: zod.uuid().describe("Service Function identity."),
});

export const AddServiceFunctionResponse = zod.uuid().describe("Service Function identity.");

/**
 * @summary Remove service function
 */
export const RemoveServiceFunctionResponse = zod.void();
